import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { withTranslation, Trans } from 'react-i18next';

import { makeGetCurrentTeam } from '../selectors/teams';
import { makeGetIsOnTrial, makeGetSubscriptionIsExpired, makeGetRemainingTrial, makeGetSubscriptionIsPastDue } from '../selectors/billing';

import { showModal } from '../actions/modal';

import config from '../config';
import { trackEvent } from '../services/events-tracker-service';
import { getToday } from '../utils/date';

import { useIsBillingOwner } from 'shared-hooks/billing';

import Alert from './alert';

const SubscriptionAlert = ({ history, isExpired, isPastDue, isOnTrial, remainingTrial, t }) => {
    const isBillingOwner = useIsBillingOwner();

    const handleUpgradeClick = useCallback(event => {
        trackEvent('TRIAL_UPGRADE_BANNER.CLICK');
        event.preventDefault();

        showModal('SWITCH_PLAN');
    }, []);

    const handleBillingClick = useCallback(event => {
        event.preventDefault();

        history.push(`/settings/team/current/billing`);
    }, [history]);

    if (isExpired) {
        return (
            <Alert type="default">
                {
                    isBillingOwner ?
                    config.BILLING_ENABLED ? (
                        <Trans
                            i18nKey="billing:alerts.expiredActivate"
                            components={{
                                Button: <button className="btn btn-link btn-link-bold btn-link-underlined" onClick={handleUpgradeClick} />
                            }}
                        />
                    ) : t('alerts.expiredActivateFromWeb') : t('alerts.expiredActivateContactOwner')
                }
            </Alert>
        )
    }

    if (isPastDue && isBillingOwner) {
        return (
            <Alert type="default">
                <Trans
                    i18nKey="billing:alerts.pastDueUpdate"
                    components={{
                        Button: <a href="" onClick={handleBillingClick} />
                    }}
                />
            </Alert>
        )
    }

    if (isOnTrial && isBillingOwner && remainingTrial <= 0) {
        return (
            <Alert type="default">
                <Trans
                    i18nKey="billing:alerts.expiredActivate"
                    values={{
                        count: remainingTrial
                    }}
                    components={{
                        Button: <button className="btn btn-link btn-link-bold btn-link-underlined" onClick={handleUpgradeClick} />
                    }}
                />
            </Alert>
        )
    }

    return null;


}

const makeMapStateToProps = () => {
    const getCurrentTeam = makeGetCurrentTeam();
    const getIsOnTrial = makeGetIsOnTrial();
    const getSubscriptionIsExpired = makeGetSubscriptionIsExpired();
    const getRemainingTrial = makeGetRemainingTrial();
    const getSubscriptionIsPastDue = makeGetSubscriptionIsPastDue();

    return ({ teams }) => {
        const currentTeam = getCurrentTeam(teams);
        const isOnTrial = getIsOnTrial(currentTeam);
        const remainingTrial = isOnTrial && getRemainingTrial(currentTeam, getToday().valueOf());

        return {
            isOnTrial,
            remainingTrial,
            isExpired: currentTeam && getSubscriptionIsExpired(currentTeam),
            isPastDue: currentTeam && getSubscriptionIsPastDue(currentTeam)
        }
    };
};

export default connect(makeMapStateToProps)(withTranslation('billing')(SubscriptionAlert));
